import React from 'react';
import classnames from 'classnames';
import { LogoIcon } from 'components/Icons/Logo';
import cn from './styles.module.scss';

type LoaderProps = {
  text?: string;
  hideText?: boolean;
  className?: string;
};

export const Loader = ({ text = 'Loading', hideText, className = '' }: LoaderProps) => (
  <div data-testid='LoaderIcon' className={classnames(cn.loader, className)}>
    {!hideText && (<span>{text}</span>)}
    <LogoIcon />
  </div>
);
